import * as Yup from 'yup';

import { translate } from '@utils';

export const getValidationSchema = () => {
  return {
    incomeConsistency: Yup.string().required(
      translate('subModules/incomeConsistency:validation.required')
    ),
  };
};
